import script from "./SimpleCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleCard.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleCard.vue?vue&type=style&index=0&id=59ca8b1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ca8b1c"]])

export default __exports__